module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsSAAALEgHS3X78AAAA9UlEQVQ4y62TzXWDMBCEP/QowCXQQUgFpgO4zF3pIKWkg3BmL9ABriBOByohHZDL4if7Ef8kmZOk3VnN/hXLspDDzCIQgT3nOAC9pD5/LNYAZlYBI/AETH5O7lcBHdACn0AnKZ0COPnohCjpyAbMrAZ6D1hLSsFt62/NT2QAtzXuOwIUwzBE4B14vkbeUPIBvAQv2HQvOVMyATF4tUcexwjsS7+kTNrbDeKrK0gA5YVxt9F/NnxOKLM+I2kGijtTqACCT1j3ixp0wCH4YLSePw+0sQX6dRLXFjaSvm6Qd8DsKdchk1MB8zUlbpuz3finZfrLOn8Dmnhzi7vQHJwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/Minus.png
// module id = 181
// module chunks = 0 1